import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  TextField,
  CircularProgress,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import { useTranslation } from "localization/translation";
import { Lang } from "components";
import useStore from "context";


const PlanInfoModal = ({
  title,
  accept,
  close,
  isOpen,
  loading,
  planInfoData,
  handleChangeData,
}) => {
  const translation = useTranslation();
  const { lang } = useStore();

  return (
    <Dialog
      classes={{
        paper: `modal-content rounded-lg`,
      }}
      open={isOpen}
      onClose={close}
      aria-labelledby="form-dialog-title"
    >
      <form onSubmit={accept}>
        <DialogTitle className="px-4">{title}</DialogTitle>
        <Lang />
        <div className="px-4">
          <div className="my-3">
            <TextField
              id="outlined-basic"
              label={translation.name}
              variant="outlined"
              value={planInfoData[`name_${lang}`]}
              type="text"
              className="w-full"
              onChange={(e) => handleChangeData(`name_${lang}`, e.target.value)}
            />
          </div>
          <div className="my-3">
            <TextField
              id="outlined-basic"
              label={translation.trial_period_days}
              variant="outlined"
              value={planInfoData.trial_period_days}
              type="text"
              className="w-full"
              onChange={(e) => handleChangeData('trial_period_days', e.target.value)}
            />
          </div>
          <div className="my-3">
            <FormControlLabel
              control={
                <div className="m-2">
                  <Switch
                    onClick={(e) => {
                      handleChangeData('unlimited_items', e.target.checked);
                    }}
                    checked={!!planInfoData?.unlimited_items}
                    className="switch-medium toggle-switch-first"
                  />
                </div>
              }
              // label={translation.enable_disable}
              label={'Is Unlimited Inventories'}
            />
          </div>
          {
            !planInfoData?.unlimited_items && (
              <>
                <div className="my-3">
                  <TextField
                    id="outlined-basic"
                    label={translation.max_inventories_count + "(" + translation.ml + ")"}
                    variant="outlined"
                    value={planInfoData.max_inventory_items_ml}
                    type="text"
                    className="w-full"
                    onChange={(e) => handleChangeData('max_inventory_items_ml', e.target.value)}
                  />
                </div>
                <div className="my-3">
                  <TextField
                    id="outlined-basic"
                    label={translation.max_inventories_count + "(" + translation.kg + "/" + translation.pc + ")"} 
                    variant="outlined"
                    value={planInfoData.max_inventory_items_kg_pc}
                    type="text"
                    className="w-full"
                    onChange={(e) => handleChangeData('max_inventory_items_kg_pc', e.target.value)}
                  />
                </div>
              </>
            )
          }
        </div>
        
        <DialogActions className="d-flex mx-auto p-4">
          <Button
            onClick={close}
            variant="contained"
            type="button"
            className=""
          >
            {translation.no}
          </Button>
          <Button
            color="secondary"
            type="submit"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : translation.yes}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PlanInfoModal;
